import axios from "axios";
import CryptoJS from 'crypto-js';
import { logOutRedirectCall } from '../pages/Common/RedirectPathMange'

var key = CryptoJS.enc.Hex.parse('SuiCovwpMpoRQbNfTmDXHWVkQWdanYOm');
var iv = CryptoJS.enc.Hex.parse('SuiCovwpMpoRQbNf');

const showMessage = (msg) => {
  // console.log(msg)
}

const axiosClient = axios.create({

  // baseURL: 'http://99.79.109.5:8015/api',
  // baseURL: 'http://13.234.122.246:8625/api',
  baseURL: 'https://api.studentscholars.com/api',
  headers: {
    'api-key': 'voRJA+cryPBoUoQh/k7q7obQN1nmg7CaY8Vt49+5lxg=',
    'Accept-Language': 'en',
    'Content-Type': 'text/plain',
  }
});

// Body Encryption Request
axiosClient.interceptors.request.use(function (request) {
  request.data = bodyEncryption(request.data ? request.data : {}, true)
  // console.log(request.data);

  if (localStorage.getItem("AToken") !== undefined || localStorage.getItem("AToken") !== null) {
    // request.headers['token'] = bodyEncryption(JSON.stringify(localStorage.getItem("AToken")), false)
    request.headers['token'] = bodyEncryption(localStorage.getItem("AToken"), false);
  }

  return request;
});

axiosClient.interceptors.response.use(

  function (response) {

    response = bodyDecryption(response.data);

    var respData = response;

    if (respData.code == -1) {
      logOutRedirectCall();
      return;
    }

    if (response.code == 0) {
      showMessage(response.message)
    }
    return response;

  },

  function (error) {
    let res = error.response;
    if (res.status == 401) {
      logOutRedirectCall()
    }
    console.error("Looks like there was a problem. Status Code: " + res.status);
    return Promise.reject(error);
  }
);

function bodyEncryption(request, isStringify) {
  var request = (isStringify) ? JSON.stringify(request) : request;
  var encrypted = CryptoJS.AES.encrypt(request, key, { iv: iv });
  return encrypted.toString();
}

function bodyDecryption(request) {
  var decrypted = CryptoJS.AES.decrypt(request.toString(), key, { iv: iv });
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
}

function encryptURL(url) {
  const [baseUrl, params] = url.split('?');
  if (!params) return url;

  const encrypted = CryptoJS.AES.encrypt(params, key, { iv: iv }).toString();
  return `${baseUrl}?${encodeURIComponent(encrypted)}`;
}

// function encryptURL(url) {
//   const [baseUrl, params] = url.split('?');
//   if (!params) return url;

//   const encrypted = CryptoJS.AES.encrypt(params, key, { iv }).toString();

//   // Make URL safe
//   const safeEncrypted = encrypted
//     .replace(/\+/g, '-')
//     .replace(/\//g, '_')
//     .replace(/=+$/, '');

//   return `${baseUrl}?${encodeURIComponent(safeEncrypted)}`;
// }

function decryptURL(url) {
  const [baseUrl, encryptedParams] = url.split('?');


  if (!encryptedParams) return url;

  const decrypted = CryptoJS.AES.decrypt(decodeURIComponent(encryptedParams), key, { iv: iv });
  const params = decrypted.toString(CryptoJS.enc.Utf8);
  return `${baseUrl}?${params}`;
}

function encryptString(text) {
  console.log('text :', text);
  let encrypted_url = encodeURIComponent(CryptoJS.AES.encrypt(`${text}`, key, { iv: iv }).toString());
  console.log('encrypted_url :', encrypted_url);
  return `${encrypted_url}`;
}

/* ===== ADMIN LOGIN FLOW - START ===== */
// Used by the Admin Login flow (Admin clicks on a Teacher's full name).
// The password stored in the database is AES encrypted with the same KEY/IV,
// so it can be decrypted here to pre-fill the teacher login screen.
function decryptString(text) {
  try {
    if (text == undefined || text == null || text == '') return '';
    const decrypted = CryptoJS.AES.decrypt(`${text}`, key, { iv: iv });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.log('decryptString error :', error);
    return '';
  }
}
/* ===== ADMIN LOGIN FLOW - END ===== */

export { axiosClient, encryptURL, decryptURL, encryptString, decryptString };